import { inMemoryRecipes } from './inMemoryRecipes';

export const inMemoryFetchCookbookTransformationBySlug = (slug: string) => inMemoryRecipes.find((recipe) => recipe.slug === slug);
